import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ClientContractAutomaticData } from '@interfaces/companys/contracts/responses/client-contract.response';
import { VaultMaskCnpjPipe } from '@src/app/shared/pipes/vault-mask-cnpj.pipe';
import { SharedModule } from '@src/app/shared/shared.module';
import { describeClientContractAddress } from '../../utils/client-contract.utils';

/**
 * Dados do cadastro da empresa que entram no contrato de cliente sem edição (card 3643):
 * qualificação da CONTRATANTE (razão social, CNPJ, endereço) e representante legal. Só leitura,
 * com o aviso do que falta e o atalho para corrigir no cadastro (quem usa decide o que o atalho faz).
 */
@Component({
  selector: 'app-client-contract-automatic-data',
  standalone: true,
  imports: [CommonModule, SharedModule, VaultMaskCnpjPipe],
  templateUrl: './client-contract-automatic-data.component.html',
  styleUrls: ['./client-contract-automatic-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientContractAutomaticDataComponent {
  readonly data = input<ClientContractAutomaticData | null>(null);
  /** O que falta no cadastro ("Representante legal", "Número do endereço"). */
  readonly missing = input<string[] | null | undefined>([]);
  readonly loading = input(false);
  /** Finalizado: os dados ficaram congelados na finalização. */
  readonly frozen = input(false);
  /** Texto do atalho de correção; vazio esconde o atalho. */
  readonly fixLabel = input('Corrigir no cadastro da empresa');

  /** Clique no atalho de correção. */
  readonly fix = output<void>();

  readonly address = computed(() => describeClientContractAddress(this.data()));
  readonly missingList = computed(() => this.missing() ?? []);
}
